import type { ModuleSettings } from '../ECommercePage';
import type { BrandFlowSettings } from './brandFlow/types';

export type HomepageModuleTemplateId = 'default' | 'category-row' | 'brand-flow';

export const DEFAULT_BRAND_FLOW_SETTINGS: BrandFlowSettings = {
  backgroundColor: '#F3F6F3',
  subtitle: '',
  subtitleStyles: {
    fontFamily: 'Inter',
    fontSize: 12,
    color: '#B8A07A',
    bold: true,
    italic: false,
  },
  footerText: '',
  footerStyles: {
    fontFamily: 'Inter',
    fontSize: 13,
    color: '#9CA3AF',
    bold: false,
    italic: false,
  },
  speedSeconds: 40,
  logoHeight: 36,
  cardBackground: '#FFFFFF',
  gapPx: 16,
  pauseOnHover: true,
  source: 'inventory',
  brandIds: [],
  items: [],
};

export const applyHomepageModuleTemplate = (
  base: ModuleSettings,
  template: HomepageModuleTemplateId
): ModuleSettings => {
  if (template === 'brand-flow') {
    return {
      ...base,
      productSource: 'manual',
      moduleTemplate: 'brand-flow',
      selectedProductIds: [],
      selectedCategoryIds: [],
      titleStyles: {
        ...base.titleStyles,
        fontSize: 32,
        color: '#1a472a',
        bold: true,
        italic: false,
        fontFamily: 'Georgia',
        textAlign: 'center',
      },
      brandFlow: {
        ...DEFAULT_BRAND_FLOW_SETTINGS,
        ...(base.brandFlow || {}),
      },
    };
  }

  if (template !== 'category-row') {
    return {
      ...base,
      productSource: 'manual',
      moduleTemplate: 'default',
    };
  }

  const currentImage = base.moduleImage || {
    imageUrl: '',
    width: 600,
    height: 400,
    alignment: 'center' as const,
    productLayout: { rows: 1, columns: 3 },
  };

  return {
    ...base,
    productSource: 'category',
    moduleTemplate: 'category-row',
    showViewAllButton: true,
    viewAllButtonText: 'Tümü',
    categoryProductLimit: 3,
    maxProducts: 3,
    selectedProductIds: [],
    selectedCategoryIds: base.selectedCategoryIds || [],
    titleStyles: {
      ...base.titleStyles,
      textAlign: 'left',
    },
    moduleImage: {
      ...currentImage,
      productLayout: { rows: 1, columns: 3 },
      productCardStyle: {
        ...(currentImage.productCardStyle || {}),
        cardEnabled: true,
        displayMode: 'grid',
        showProductName: true,
        showPrice: true,
      },
    },
  };
};
